import { render, staticRenderFns } from "./testVaccinationHistory.vue?vue&type=template&id=3a6a05b0"
import script from "./testVaccinationHistory.vue?vue&type=script&lang=js"
export * from "./testVaccinationHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a6a05b0')) {
      api.createRecord('3a6a05b0', component.options)
    } else {
      api.reload('3a6a05b0', component.options)
    }
    module.hot.accept("./testVaccinationHistory.vue?vue&type=template&id=3a6a05b0", function () {
      api.rerender('3a6a05b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/testVaccinationHistory.vue"
export default component.exports